module.exports = __webpack_public_path__ + "static/media/box.6447bfbd.png";